import type { ToolConfig } from '@empathybroker/tsclient-play/dist/models/instance/domains/tools/tool-config'
import type { ToolsConfig } from '@empathybroker/tsclient-play/dist/models/instance/domains/tools/tools-config'
import type { ComputedRef } from 'vue'
import type { ContextState } from '../models/store/context/context.state'
import { computed, getCurrentInstance } from 'vue'
import { CONTEXT_CONSTS } from '../store/context/context.consts'
import { useFeature } from './use-feature'
import { useInstance } from './use-instance'
import { mapGetters } from './utils'

interface InstanceToolConfigInstanceComposable<T = ToolConfig> {
  toolConfig: ComputedRef<T>
}

export function useInstanceToolConfig<T = ToolConfig>(): InstanceToolConfigInstanceComposable<T> {
  const ctx = getCurrentInstance()

  if (!ctx) {
    throw new Error("'ctx' is not defined")
  }

  const { context } = mapGetters<ContextState>(ctx.proxy.$store, CONTEXT_CONSTS.moduleName, {
    context: CONTEXT_CONSTS.getters.context,
  })

  const { featureId } = useFeature()

  const { instanceConfig } = useInstance()

  const toolConfig = computed(() => {
    const domainConfig = instanceConfig.value.domains[context.value.domain] as unknown as {
      tools: ToolsConfig & { [key: string]: T }
    }

    const toolsConfig = domainConfig?.tools

    const toolConfig = Object.assign(
      {},
      !!toolsConfig && {
        ...toolsConfig.base,
        ...toolsConfig[featureId.value],
      },
    )

    return toolConfig
  })

  return {
    toolConfig,
  }
}
